import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IDateRangeFilter } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/inner/IDateRangeFilter'
import { IsRequired } from 'submodules/nerit-framework-utils/validators'
import { IsOptional } from 'class-validator'

export class GeographicChartFiltersFormModel extends FormModel {

    @IsRequired()
    locationCodes: number[]

    @IsRequired()
    fieldCode: number

    @IsOptional()
    dateRange?: IDateRangeFilter

    @IsOptional()
    fieldRegulationCode?: number

    @IsOptional()
    samplingCode?: number

    regulationName?: string
    fieldName: string

    constructor(initialData?: Partial<GeographicChartFiltersFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
